import SlotRangePicker from './SlotRangePicker';
import { useState, useEffect } from 'react';

export default function FromAndToRangePicker({ slotData, selectedSlot, setSelectedSlot, selectedDate, intervalData }) {
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [active, setActive] = useState({
    hour: 0,
    minute: 0,
  });

  console.log('hello time', selectedSlot);

  useEffect(() => {
    setSelectedSlot({
      //   id: '',
      time: fromTime,
      toTime,
    });
  }, [fromTime, toTime]);

  //   useEffect(() => {
  //     if (!selectedSlot?.time) {
  //       setFromTime('');
  //       setToTime('');
  //       setActive({ hour: 0, minute: 0 });
  //     }
  //   }, [selectedDate]);

  //   useEffect(() => {
  //     console.log('hello selectedSlot', selectedSlot);
  //     setFromTime(selectedSlot?.time);
  //     setToTime(selectedSlot?.toTime);
  //   }, [selectedSlot]);

  return (
    <div className="from-to-container">
      <div className="slot-range-picker-item">
        <span className="slot-range-picker-label">From</span>
        <SlotRangePicker
          initialTime={selectedSlot?.time ?? ''}
          slotData={slotData}
          onChange={val => {
            console.log('picked:', val);
            setFromTime(val);
          }}
          type="from"
          active={active}
          setActive={setActive}
        />
      </div>
      <div className="divider-vertical"></div>
      <div className="slot-range-picker-item">
        <span className="slot-range-picker-label">To</span>
        <SlotRangePicker
          slotData={slotData}
          onChange={val => {
            console.log('picked:', val);
            setToTime(val);
          }}
          type="to"
          active={active}
          setActive={setActive}
          intervalData={intervalData}
        />
      </div>
    </div>
  );
}
